export default [
    {
        path: '/short-url/list',
        name: 'short_url_list',
        component: () => import('@src/short-url/short-url-list'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Alle Marketing-Url`s',
            role: 'ROLE_LIST_SHORT_URL',
        },
    },
    {
        path: '/short-url/create',
        name: 'short_url_create',
        component: () => import('@src/short-url/short-url.vue'),
        meta: {
            title: 'Marketing-Url erstellen',
            role: 'ROLE_EDIT_SHORT_URL',
        },
    },
    {
        path: '/short-url/edit/:id?',
        name: 'short_url_edit',
        component: () => import('@src/short-url/short-url.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Marketing-Url bearbeiten',
            role: 'ROLE_EDIT_SHORT_URL',
        },
    },
];
